<template>
  <aside id="offcanvas-sidemenu" class="app-sidebar -translate-x-full xl:translate-x-0" aria-label="Sidebar">
    <div id="logo-cont" class="app-sidebar-logo-container">
      <RouterLink :to="ROUTER.ADMIN.HOME_PAGE.PATH">
        <a href="javascript:void(0);" data-drawer-hide="offcanvas-sidemenu">
          <img src="../../assets/branch-logo.svg" class="app-sidebar-logo" alt="Digital Hands Logo" />
        </a>
      </RouterLink>
    </div>
    <div id="menu-cont" class="app-sidebar-menu-container">
      <SideMenu side-menu-id="offcanvas-sidemenu" :items="menuItems" @on-item-click="handleItemClick" />
    </div>
  </aside>
</template>

<script setup lang="ts">
import { markRaw, onMounted, ref } from 'vue';
import { RouterLink } from 'vue-router';
import { initFlowbite } from 'flowbite';

import HomeIcon from '@/components/icons/HomeIcon.vue';

import { ROUTER } from '@/app-constants/router.constant';
import { SideMenuItem } from '@/entities/sideMenuItem.entity';
import SideMenu from './SideMenu.vue';

const menuItems = ref<SideMenuItem[]>([]);

const buildSideMenuItems = (): void => {
  // Homepage
  menuItems.value.push({
    id: ROUTER.PARTNER.LANDING_PAGE.KEY,
    name: ROUTER.PARTNER.LANDING_PAGE.NAME,
    link: ROUTER.PARTNER.LANDING_PAGE.PATH,
    icon: markRaw(HomeIcon),
  });
};

const handleItemClick = (item: SideMenuItem): void => {
  const itemFromList = menuItems.value.find((menuItem) => menuItem.id === item.id);
  itemFromList?.children?.length && (itemFromList.expanded = !itemFromList.expanded);
};

onMounted(() => {
  buildSideMenuItems();
  initFlowbite();
});
</script>
